import { useCallback } from 'react'

import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HStack } from 'govwell-ui'

import { formatCityState } from 'src/utils'

import { OrganizationMembership } from '../../hooks/use-my-organization-memberships'

export const getOrgLabel = (membership: OrganizationMembership): string => {
  const { organization } = membership
  return organization.displayName || formatCityState(organization.city, organization.state)
}

type Props = {
  membership: OrganizationMembership
  index: number
  isCurrentOrg: boolean
  isHighlighted: boolean
  setActiveIndex: (index: number) => void
  onSelect: (membership: OrganizationMembership) => void
  rowRef: (el: HTMLElement | null) => void
}

const OrgRow = (props: Props) => {
  const { membership, index, isCurrentOrg, isHighlighted, setActiveIndex, onSelect, rowRef } = props
  const label = getOrgLabel(membership)

  const handleMouseMove = useCallback(() => {
    setActiveIndex(index)
  }, [setActiveIndex, index])

  const handleClick = useCallback(() => {
    onSelect(membership)
  }, [onSelect, membership])

  return (
    <button
      ref={rowRef}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      data-selected={isHighlighted}
      className={`w-full cursor-pointer rounded-md px-3 py-2 text-left text-sm transition-colors ${
        isCurrentOrg
          ? 'bg-primary-100 text-primary-700 font-semibold data-[selected="true"]:bg-neutral-100'
          : 'text-neutral-950 data-[selected="true"]:bg-neutral-100'
      }`}
    >
      <HStack gap={1} justify="space-between" align="center">
        <span className="min-w-0 flex-1 truncate">{label}</span>
        {isCurrentOrg && (
          <FontAwesomeIcon icon={faCheck} className="text-primary-600 h-3.5 w-3.5 flex-shrink-0" />
        )}
      </HStack>
    </button>
  )
}

export default React.memo(OrgRow)
